import { LayoutDefault } from "@/components/layouts/LayoutDefault";
import { RegisterProvider } from "@/services/context/register";
import { Outlet, createFileRoute } from "@tanstack/react-router";

const RegisterLayout = () => (
  <LayoutDefault>
    <RegisterProvider>
      <Outlet />
    </RegisterProvider>
  </LayoutDefault>
);

export const Route = createFileRoute("/register")({
  component: RegisterLayout,
});
